import { Suspense, lazy } from "react";

import { Route } from "react-router-dom";

import SecureRoute from "shared/services/AuthDecorator/SecureRoute";
import BasicLayout from "shared/templates/Layouts/BasicLayout";

import type { IApp } from "shared/types";

import ProfileLayout from "./Layouts/ProfileLayout";

const ProfileDashboardPage = lazy(() => import("./Pages/Dashboard"));
const ProfileBonusesPage = lazy(() => import("./Pages/Bonuses"));
const ProfileLoyaltyPage = lazy(() => import("./Pages/Loyalty"));
const ProfileTransactionsPage = lazy(() => import("./Pages/Transactions"));
const ProfileHistoryPage = lazy(() => import("./Pages/History"));
const ProfileGeneralPage = lazy(() => import("./Pages/General"));

import { routes } from "./constants";

class ProfileApp implements IApp {
	getRoutes = () => [
		<Route key="profile-routes" path={routes.profile.getPath()} element={<BasicLayout />}>
			<Route element={<SecureRoute roles={[]} />}>{this.getSecuredRoutes()}</Route>
		</Route>
	];

	getSecuredRoutes = () => [
		<Route key="profile-inner-routes" element={<ProfileLayout />}>
			<Route
				key={routes.profile.dashboard.getElementKey()}
				path={routes.profile.dashboard.getPath()}
				element={
					<Suspense>
						<ProfileDashboardPage />
					</Suspense>
				}
			/>
			<Route
				key={routes.profile.bonuses.getElementKey()}
				path={routes.profile.bonuses.getPath()}
				element={
					<Suspense>
						<ProfileBonusesPage />
					</Suspense>
				}
			/>
			<Route
				key={routes.profile.loyalty.getElementKey()}
				path={routes.profile.loyalty.getPath()}
				element={
					<Suspense>
						<ProfileLoyaltyPage />
					</Suspense>
				}
			/>
			<Route
				key={routes.profile.transactions.getElementKey()}
				path={routes.profile.transactions.getPath()}
				element={
					<Suspense>
						<ProfileTransactionsPage />
					</Suspense>
				}
			/>
			<Route
				key={routes.profile.history.getElementKey()}
				path={routes.profile.history.getPath()}
				element={
					<Suspense>
						<ProfileHistoryPage />
					</Suspense>
				}
			/>
			<Route
				key={routes.profile.general.getElementKey()}
				path={routes.profile.general.getPath()}
				element={
					<Suspense>
						<ProfileGeneralPage />
					</Suspense>
				}
			/>
		</Route>
	];
}

export default ProfileApp;
